import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EditableTableComponent } from '../editable-table-v2/editable-table.component';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { SharedModule } from '../../modules/shared/shared.module';
import { EditableTableMeta } from '../../models/editable-table-header.interface';

@Component({
  selector: 'app-editable-grid-form',
  standalone: true,
  imports: [EditableTableComponent, SvgIconComponent, SharedModule],
  templateUrl: './editable-grid-form.component.html',
  styleUrl: './editable-grid-form.component.scss'
})
export class EditableGridFormComponent {
  
  @Input() tableConfig!: EditableTableMeta;
  @Input() tableData: any[] = [];
  @Input() disable: boolean = false;
  @Input() width?: string;


  @Output() publish = new EventEmitter<any[]>();
  @Output() dataChanged = new EventEmitter<any>();


  ngOnInit() {
    console.log(this.tableConfig);
    if (this.tableData.length == 0) {
      this.addNewRow();
    }
  }

  addNewRow() {
    if (!this.tableConfig?.columns) return;

    console.log("Inside New row");

    const newRow: any = {};

    for (const column of this.tableConfig.columns) {
      if (column.editable) {
        const defaultValue = column.defaultValue ?? this.getDefaultByType(column.dataType);
        newRow[column.fieldName] = defaultValue;
      }
    }

    this.tableData.push(newRow);
  }

  private getDefaultByType(dataType: string): any {
    switch (dataType) {
      case 'NUMBER': return 0;
      case 'BOOLEAN': return false;
      case 'STRING': return '';
      case 'DATE': return null;
      case 'SELECT': return null;
      default: return null;
    }
  }

  handleTableDataChange(event: any) {
    this.dataChanged.emit(event);
  }

  handleInlineAction(event: { actionName: string, index: number }) {
    if (event.actionName === "delete") {
      this.tableData.splice(event.index, 1);
    }
  }

  publishUpdatedList(): void {
    const cleanedData = this.tableData.filter(row => !this.isRowEmpty(row));
    this.publish.emit(cleanedData);
  }

  private isRowEmpty(row: any): boolean {
    return this.tableConfig.columns.every(column => {
      const value = row[column.fieldName];
      return value === null || value === undefined || value === '';
    });
  }
}
